import TripGroup from '../components/views/trip-group/TripGroup.vue'
import TripGroupCreate from '../components/views/trip-group/Trip-Group-Create.vue'
import TripCreate from '../components/views/trip/TripCreate.vue'
import TripGroupDetail from '../components/views/trip-group/TripGroupDetail.vue'
import TripGroupActivity from '../components/views/trip-group/Trip-Group-Activity.vue'
import UpComingTrip from '../components/views/trip/UpComingTrip.vue'
import OnGoingTrip from '../components/views/trip/OnGoingTrip.vue'
import CompletedTrip from '../components/views/trip/CompletedTrip.vue'
import UpdateLocations from '../components/views/trip-group/Update-Locations.vue'
const routes = [{
    path: '/trip-group',
    component: TripGroup,
    name: 'TripGroup',
    meta: {
        description: 'List of Think Gas Group Trips',
        title: 'Group Trip',
        requiresAuth: true
    }
},
{
    path: 'trip-group/create',
    component: TripGroupCreate,
    name: 'TripGroupCreate',
    meta: {
        description: 'Add a new Group Trip',
        title: 'Add Group Trip',
        requiresAuth: true
    }
},
{
    path: '/trip-group/:_id',
    beforeEnter: (to, from, next) => {
        to.params._id === 'create' &&
            (to.params.status === 'ongoing' && to.params.status === 'completed') ?
            next({ name: 'TripCreate' }) :
            next()
    },
    component: TripGroupActivity,
    name: 'Trip-Group-Activity',
    meta: {
        description: 'Activity log of Group Trip',
        title: 'Group Trip Activity',
        requiresAuth: true
    }
},
{
    path: '/trip-group/:_id/status',
    beforeEnter: (to, from, next) => {
        to.params._id === 'create' &&
            (to.params.status === 'scheduled' || to.params.status === 'halt') ?
            next({ name: 'TripCreate' }) :
            next()
    },
    component: TripGroupDetail,
    name: 'TripGroupDetail',
    meta: {
        description: 'Details for the selected Group trip',
        title: 'Update Group Trip',
        requiresAuth: true
    }
},

{
    path: '/scheduledTrip',
    component: UpComingTrip,
    name: 'UpComing',
    meta: {
        title: 'Scheduled Group Trips',
        description: 'ThinkGas Scheduled Group Trips'
    }
},
{
    path: '/ongoingTrip',
    component: OnGoingTrip,
    name: 'OnGoing',
    meta: {
        title: 'Ongoing Group Trips',
        description: 'ThinkGas Ongoing Group Trips'
    }
},
{
    path: '/completedTrip',
    component: CompletedTrip,
    name: 'Completed',
    meta: {
        title: 'Completed Group Trips',
        description: 'ThinkGas Completed Group Trips'
    }
},
{
    path: 'trip-group/updateDestination',
    beforeEnter: (to, from, next) => {
        to.params._id === 'create' ? next({ name: 'UpdateDestination' }) : next()
    },
    component: UpdateLocations,
    name: 'UpdateLocations',
    meta: {
        requiresAuth: true
    }
}
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/trip-group.route.js